try{self['workbox:navigation-preload:4.3.1']&&_()}catch(e){}// eslint-disable-line